import ReleaseHelper from 'models/Release';

export default class Song {
	static getPublisher = item => {
		if (item.labels && item.labels.length > 0) {
			return item.labels[0].name;
		}
		return '';
	}
	static addReleaseFields = (song, release) => {
		return {
			...song,
			releaseid: release.releaseId,
			publisher: ReleaseHelper.getPublisher(release),
			coverart: release.coverart,
			candownload: release.candownload,
			available: release.available
		};
	}
}
